function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var zenSigletonMapping = {};
export var zenSigleton = /*#__PURE__*/function () {
  function zenSigleton() {
    _classCallCheck(this, zenSigleton);
  }
  _createClass(zenSigleton, null, [{
    key: "get",
    value: function get(name) {
      var _window, _window2;
      if (((_window = window) === null || _window === void 0 ? void 0 : _window._zenSigleon) === undefined) {
        window._zenSigleon = {};
      }
      if ((_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2._zenSigleon) !== null && _window2 !== void 0 && _window2[name]) {
        return window._zenSigleon[name];
      } else {
        console.error("[ZenSigleton]Error:unable to find ".concat(name, ", initialize and register sigleton first"));
      }
    }
  }, {
    key: "regist",
    value: function regist(name, data, opts) {
      var _window3;
      if (((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3._zenSigleon) === undefined) {
        window._zenSigleon = {};
      }
      if (!window._zenSigleon[name] || opts !== null && opts !== void 0 && opts.force) {
        window._zenSigleon[name] = data;
        zenSigletonMapping[name] = opts;
      } else {
        if (opts !== null && opts !== void 0 && opts.silent) {
          return;
        }
        console.error("[ZenSigleton]Warn:".concat(name, " already exist,regist failed or you can user regist(").concat(name, ",YOUR_DATA,{force:true}) to force replace."));
      }
    }
  }, {
    key: "getConig",
    value: function getConig(name) {
      return zenSigletonMapping === null || zenSigletonMapping === void 0 ? void 0 : zenSigletonMapping[name];
    }
  }, {
    key: "has",
    value: function has(name) {
      var _window4;
      return !!((_window4 = window) !== null && _window4 !== void 0 && (_window4 = _window4._zenSigleon) !== null && _window4 !== void 0 && _window4[name]);
    }
  }]);
  return zenSigleton;
}();